<template>
<div class="chapter">
<div class="inner_page">
<p class="book-pages---regular"><span class="charoverride"><br class="calibre1"/></span></p>
<h1 class="book-pages---regular"><span class="charoverride">Contents</span></h1>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Title_Page" title="Link target outside of Sample">Death by Water</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Copyright" title="Link target outside of Sample">Copyright</span>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Contents">Contents</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Dedication">Dedication</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Epigraph">Epigraph</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Chapter_1">Chapter One</a>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Chapter_2">Chapter Two</a>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_3" title="Link target outside of Sample">Chapter Three</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_4" title="Link target outside of Sample">Chapter Four</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_5" title="Link target outside of Sample">Chapter Five</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_6" title="Link target outside of Sample">Chapter Six</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_7" title="Link target outside of Sample">Chapter Seven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_8" title="Link target outside of Sample">Chapter Eight</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_9" title="Link target outside of Sample">Chapter Nine</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_10" title="Link target outside of Sample">Chapter Ten</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_11" title="Link target outside of Sample">Chapter Eleven</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_12" title="Link target outside of Sample">Chapter Twelve</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_13" title="Link target outside of Sample">Chapter Thirteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_14" title="Link target outside of Sample">Chapter Fourteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_15" title="Link target outside of Sample">Chapter Fifteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_16" title="Link target outside of Sample">Chapter Sixteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_17" title="Link target outside of Sample">Chapter Seventeen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_18" title="Link target outside of Sample">Chapter Eighteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_19" title="Link target outside of Sample">Chapter Nineteen</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Chapter_20" title="Link target outside of Sample">Chapter Twenty</span>
</div>
<div class="sgc-toc-level">
<a href="#/OEBPS/Text/Author's_Note">Author’s Note and Pre-Emptive Apology</a>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Bibliography" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/More_from_this_Author" title="Link target outside of Sample">More from this Author</span>
</div>
<div class="sgc-toc-level">
<span href="#/OEBPS/Text/Contact_Us" title="Link target outside of Sample">Contact Us</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?93fb5ae2